<template>
	<div class="admin-dialog h-100 w-100 overflow-auto">
		<div class="wrapper-body h-100 overflow-auto" style="display: block" v-if="isaSestyemLookupsPageOpened()">
			<div class="reports_container d-flex flex-column">
				<v-toolbar class="shadow-none" style="flex: unset; padding-bottom: 10px;" content-class="h-auto">
					<div class="custom-icon-wrapper">
						<v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
					</div>
					<h2 class="dark-title size-16 my-5" style="padding-left: 10px; padding-right: 10px;">{{ $t("res_Title_ManageDocumentLookups") }}</h2>
				</v-toolbar>

				<div class="grid-4-items" style="padding-top: 15px;">
					<v-card v-if="constants.isFullAdmin" @click="openManageNotificationTemplatesPage()">
						<h4 class="dark-title size-16 pb-2">{{ $t('res_Label_ManageNotificationTemplates') }} </h4>
						<p>{{ $t('res_Label_ManageNotificationTemplatesDesc') }} </p>
					</v-card>
					<v-card v-if="constants.client_version_Id != 'DGS' && constants.isFullAdmin && this.defaultApplicationId == 1" @click="openManageCustomLookupsPage()">
						<h4 class="dark-title size-16 pb-2">{{ $t('res_Title_ManageCustomLookups') }} </h4>
						<p>{{ $t('res_Label_ManageCustomLookupsFormat') }} </p>
					</v-card>
					<v-card v-if="constants.isFullAdmin" @click="openManageResources()">
						<h4 class="dark-title size-16 pb-2">{{ $t("res_Title_ManageResources") }}</h4>
						<p>{{ $t("res_label_ManageResources") }}</p>
					</v-card>
					<v-card v-if="constants.isFullAdmin" @click="openManagePrivacy()">
						<h4 class="dark-title size-16 pb-2">{{ $t("res_Title_ManagePrivaces") }}</h4>
						<p>{{ $t("res_label_ManagePrivacesDes") }}</p>
					</v-card>
					<v-card v-if="constants.isFullAdmin" @click="openManageImportance()">
						<h4 class="dark-title size-16 pb-2">{{ $t("res_Title_ManageImportances") }}</h4>
						<p>{{ $t("res_label_ManageImportancesDes") }}</p>
					</v-card>
					<v-card v-if="constants.isFullAdmin" @click="openManagePriority()">
						<h4 class="dark-title size-16 pb-2">{{ $t("res_Title_ManagePriorities") }}</h4>
						<p>{{ $t("res_label_ManagePrioritiesDes") }}</p>
					</v-card>
					<v-card v-if="constants.isFullAdmin" @click="openManagePurpose()">
						<h4 class="dark-title size-16 pb-2">{{ $t("res_Title_ManagePurposes") }}</h4>
						<p>{{ $t("res_label_ManagePurposesDes") }}</p>
					</v-card>
				</div>
			</div>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
import router from "../../router/index.js";
import constants from "../../assets/js/constants";
import MessagesUtil from "@/utils/messagesUtil";

export default {
	name: "manageSystemLookups",
	props: {
		pageNum: { Type: Number, default: null },
	},
	data: function () {
		return {
			messagesUtil: MessagesUtil,
			constants: constants,
			defaultApplicationId: 1,
		};
	},
	mounted() {
		this.defaultApplicationId = constants.defaultApplicationId;
	},
	methods: {
		backToAdminPage() {
			router.push({ name: "admin" });
		},
		isaSestyemLookupsPageOpened() {
			return this.$route.name === "manageSystemLookups";
		},
		openManageNotificationTemplatesPage() {
			router.push({ name: "manageNotificationTemplates" });
		},
		openManageCustomLookupsPage() {
			router.push({ name: "manageCustomLookups" });
		},
		openManageResources() {
			router.push({ name: "ManageResources" });
		},
		openManagePrivacy() {
			router.push("/admin/manage-document-lookups/1");
		},
		openManageImportance() {
			router.push("/admin/manage-document-lookups/2");
		},
		openManagePriority() {
			router.push("/admin/manage-document-lookups/3");
		},
		openManagePurpose() {
			router.push("/admin/manage-document-lookups/4");
		},
	},
};
</script>